;(function (_, $) {

  $(document).on('click touch', '.js-toggle-review-form', function () {
    $(this).closest('#review_form_wrapper').addClass('active');
  })

  const scrollIntoViewIfNeeded = ($element) => {
    const rect = $element[0]?.getBoundingClientRect();

    if (!rect || (rect.top >= 0 && rect.top < window.innerHeight)) {
      return;
    }

    const negativeOffset = $('body').hasClass('admin-bar') ? 100 : 65;

    $('html, body').animate({
      scrollTop: $element.offset().top - negativeOffset
    }, 'slow');
  }

  $(document).on('click', '.js-load-more-reviews', function () {
    const $button = $(this);

    if ($button.hasClass('is-loading')) {
      return;
    }

    $button.addClass('is-loading').attr('aria-busy', 'true');

    $.ajax({
      url: TPK.ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'tpk_load_more_reviews',
        product_id: $button.data('product-id'),
        page: $button.data('page'),
      },
      success: function (response) {
        if (!response.success) {
          // Fall back to the regular (full page) comment page link.
          window.location.href = $button.data('url');
          return;
        }

        const $newReviews = $($.parseHTML(response.data.html.trim())).filter('li');

        $button.closest('.tpk-reviews-comments').find('.commentlist').append($newReviews);
        scrollIntoViewIfNeeded($newReviews.first());

        if (!response.data.next_page) {
          $button.closest('.tpk-load-more-reviews-wrapper').remove();
          return;
        }

        $button
          .data('page', response.data.next_page)
          .attr('data-page', response.data.next_page)
          .data('url', response.data.next_url)
          .removeClass('is-loading')
          .removeAttr('aria-busy');
      },
      error: function () {
        window.location.href = $button.data('url');
      }
    });
  });

  const addReviewMessage = ($formWrapper, message, type) => {
    const messageWrapper = $('<div />', {
      class: 'tpk-reviews-message ' + (type === 'success' ? 'tpk-reviews-message--success' : 'tpk-reviews-message--error'),
      html: message,
    });

    const icon = type === 'success' ? 'fa-solid fa-check-square' : 'fa-solid fa-square-xmark';
    messageWrapper.prepend($('<i class="' + icon + '" aria-hidden="true"></i>'));

    $formWrapper.append(messageWrapper);

    setTimeout(function () {
      messageWrapper.remove();
    }, 5000);
  }

  $('#review_form_wrapper').off('submit').on('submit', '#commentform', function (event) {
    event.preventDefault();

    const formData = $(this).serialize() + '&action=tpk_ajax_reviews&submit=Send&comment_type=review';
    const $form = $(this);
    const formWrapper = $form.closest('#review_form_wrapper');

    $.ajax({
      url: TPK.ajaxUrl,
      type: 'POST',
      dataType: 'json',
      cache: false,
      data: formData,
      success: function (response) {
        if( !response.success ) {
          //TODO: handle failure
          return;
        }

        $form.closest('#review_form_wrapper').removeClass('active');
        $form[0].reset();

        addReviewMessage(formWrapper, response.data.message, 'success');
      },
      error: function (xhr, status, error) {
        addReviewMessage(formWrapper, xhr.responseText, 'error');
      }
    })

    return false;
  })

})(window, jQuery);